import type { Block, ChatMessage } from '@hump/shared-types';

export interface GlossaryEntry {
  source: string;
  target: string;
}

export function buildTranslatePrompt(
  blocks: { blockId: string; text: string }[],
  sourceLang: string,
  targetLang: string,
  glossary?: GlossaryEntry[]
): { system: string; user: string } {
  const glossaryText = glossary && glossary.length > 0
    ? `\n术语对照：\n${glossary.map((g) => `- ${g.source} → ${g.target}`).join('\n')}\n`
    : '';

  const system = `你是一位专业翻译。将用户提供的${sourceLang}文本翻译为${targetLang}。
规则：
1. 保持原文的段落结构和语气
2. 专业术语按术语表翻译（如有）
3. 译文自然流畅，不是逐字翻译
4. 代码块、公式、URL 保持原样不翻译
5. 只输出译文，不输出解释。多个段落用 --- 分隔，按输入顺序输出。${glossaryText}`;

  const user = blocks.map((b) => b.text).join('\n---\n');

  return { system, user };
}

export function buildChatPrompt(
  messages: ChatMessage[],
  contextBlocks: Block[]
): { system: string; user: string } {
  const contextText = contextBlocks
    .map((b) => {
      const parts = [b.original];
      if (b.translation) parts.push(`译文：${b.translation}`);
      return parts.join('\n');
    })
    .join('\n---\n');

  const system = `你是 Hump 的阅读向导 Guide。用户正在阅读一篇文章。
以下是用户当前阅读的内容：

---
${contextText}
---

回答用户的问题。规则：
1. 用中文回答
2. 可以引用上文中的原文；引用原文时必须用 »原文« 格式包裹被引用的文字（例如：»To be or not to be«）
3. 简洁直接，不啰嗦
4. 如果问题超出当前上下文，诚实说明`;

  const lastUserMsg = [...messages].reverse().find((m) => m.role === 'user');
  const user = lastUserMsg?.content ?? '';

  return { system, user };
}

export function parseTranslateResponse(response: string, count: number): string[] {
  const parts = response.split(/\n?---\n?/);
  while (parts.length < count) parts.push('');
  return parts.slice(0, count);
}
